import React, { useState, useEffect, useContext } from "react"
import _ from "lodash"
import {
    Card,
    CardBody,
    Button,
    Row,
    Col,
    Label,
    Input,
    InputGroup,
    InputGroupAddon,
    FormGroup,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,
    DropdownToggle,
} from "reactstrap"
import ReactTable from "react-table"
import moment from "moment"
import { useTranslation } from 'react-i18next'

import { UserContext } from "context/auth";

import formatNumber from "utils/numberFormat"
import ExportTo from "./exportTable"
import CheckBox from "main_views/components/CheckBoxInput"
import { dataLimits } from 'utils/constants'

const dateFormat = 'DD/MM/YYYY HH:mm'

function CustomTable(props) {

    let { t } = useTranslation()

    let { user: currentUser } = useContext(UserContext)

    const [searchInput, setSearchInput] = useState("")
    const [data, setData] = useState([])
    const [pages, setPages] = useState()
    const [currentPage, setCurrentPage] = useState()

    // clear the search result in re-loading
    useEffect(() => {
        if (props.setFilterResult) { // the condition >> to prevent an error from tables that doesn't has this props 
            setSearchInput("")
            props.setFilterResult(props.body)
        }
    }, [props.loading, props.body])

    // update the table pages
    useEffect(() => {

        let pagesNum = Math.ceil(props.body.length / dataLimits)
        setPages(pagesNum)
        setCurrentPage(!props.loadMoreBtn ? 0 : pagesNum - 1) // Note: react-table page is zero indexing

    }, [props.body])

    // update the table pages after set search result
    useEffect(() => {
        let pagesNum = Math.ceil(data.length / dataLimits)
        setPages(pagesNum)
        setCurrentPage(!props.loadMoreBtn ? 0 : pagesNum - 1)

    }, [data])

    const columnsHandler = () => {
        // if (!props.body) return []

        let columns = props.header.map((item, index) => {

            let column = {
                key: index,
                style: { border: "none" },
                Header: _.get(item, "Header"),
                accessor: item.type === "dateAndTime" ? moment(_.get(item, "accessor", ""), 'YYYY-MM-DD hh:mm:ss').format(dateFormat) : _.get(item, "accessor", ""), // to fix sorting date column issue
                sortable: _.get(item, "sortable", true),
                show: _.get(item, "show", true),
                headerClassName: `text-primary text-center`,
                className: `${index === 0 ? "text-nowrap text-primary" : ""} text-center`,
                Cell: props => {

                    // index Cells
                    if (item.type === "index") {
                        return (
                            <div>{props.index + 1}</div>
                        )
                    }

                    // Text Cells
                    if (item.type === "string") {
                        return (
                            <div>{props.value ? props.value : item.default}</div> // set the default value if accessor value was empty
                        )
                    }

                    // date Cells
                    if (item.type === "date") {
                        return (
                            <div>{moment(props.value).format('YYYY-MM-DD')}</div>
                        )
                    }
                    if (item.type === "dateAndTime") {

                        let { redirects, approvedBy, openedAt } = props.original
                        approvedBy = _.orderBy({ ...approvedBy, ...redirects }, info => moment(info.date, 'YYYY-MM-DD hh:mm:ss'))

                        let lastAction = _.last(_.values(approvedBy))
                        let lastUpdateTime = lastAction ? moment(lastAction.date, 'YYYY-MM-DD hh:mm:ss').toDate().toLocaleString("en-GB") : openedAt.toDate().toLocaleString("en-GB")

                        return (
                            <div>{lastUpdateTime}</div>
                        )
                    }

                    // object array Cells
                    if (item.type === "array") {
                        let strings = _.map(props.value, 'name')
                        return (
                            <div>{strings.join(', ')}</div>
                        )
                    }

                    // array of string Cells
                    if (item.type === "stringArray") {
                        return (
                            <div>{props.value.join(', ')}</div>
                        )
                    }

                    // firestoreTime - show date
                    if (item.type === "firestoreTime") {
                        return (
                            <div>{props.value ? moment(props.value.toDate()).format('DD/MM/YYYY') : ''}</div>
                        )
                    }

                    // firestoreTime - show date and time
                    if (item.type === "firestoreDateAndTime") {
                        return (
                            <div>{props.value ? moment(props.value.toDate()).format('DD/MM/YYYY HH:mm') : ''}</div>
                        )
                    }

                    // Boolean Cells
                    if (item.type === "boolean") {
                        return (
                            <div>{props.value ? "Yes" : "No"}</div>
                        )
                    }

                    // Boolean Cells
                    if (item.type === "priorityTxt") { // normal | urgent | top_urgent
                        return (
                            <div>{t(props.value)}</div>
                        )
                    }

                    // Num Cells
                    if (item.type === "int" || item.type === "double" || item.type === "perc") {
                        return (
                            <div className={`${Math.sign(props.value) === -1 ? "text-danger" : ""}`}>
                                {item.type === "int" ? formatNumber(props.value, "int") : formatNumber(props.value)}
                                {item.type === "perc" ? " %" : ""}
                            </div>
                        )
                    }

                    // Button Cells
                    if (item.type === "button") {
                        return (
                            <Button
                                size="sm"
                                color={item.color}
                                outline={item.isOutline}
                                className="text-uppercase text-nowrap"
                                onClick={() => item.onClick(props.index)}>
                                {item.color === "danger" ? item.buttonTitle ? item.buttonTitle : <i className="fa fa-times" /> : item.buttonTitle}
                            </Button>
                        )
                    }

                    // Re-request Button ( shown only if Current UserId == requestedBy )
                    if (item.type === "reRequest_btn") {
                        if (_.get(currentUser, 'id') === _.get(props, 'value.requestedBy'))
                            return (
                                <Button
                                    size="sm"
                                    color={item.color}
                                    outline={item.isOutline}
                                    className="text-uppercase text-nowrap"
                                    onClick={() => item.onClick(props.value)}>
                                    {item.color === "danger" ? item.buttonTitle ? item.buttonTitle : <i className="fa fa-times" /> : item.buttonTitle}
                                </Button>
                            )

                        return <></>
                    }

                    // list of Buttons
                    if (item.type === "buttons") {
                        return (
                            _.map(item.btns, btn => (
                                <Button
                                    key={btn.buttonTitle}
                                    size="sm"
                                    color={btn.color}
                                    outline={btn.isOutline}
                                    className="text-uppercase text-nowrap"
                                    onClick={() => btn.onClick(props.index)}>
                                    {btn.color === "danger" ? <i className="fa fa-times" /> : btn.buttonTitle}
                                </Button>
                            ))
                        )
                    }

                    if (item.type == "dropDownMenu") {
                        return (
                            <UncontrolledDropdown>
                                <DropdownToggle
                                    caret
                                    size="sm"
                                    type="button"
                                    color="info"
                                    //outline={true}
                                    id="dropdownMenuButton"
                                    aria-haspopup={true}
                                    aria-expanded={false}
                                    data-toggle="dropdown"
                                    // className="float-right"
                                >
                                    {`${item.buttonTitle ?? ''} \t\t\t`}
                                </DropdownToggle>
                                <DropdownMenu aria-labelledby="dropdownMenuButton" right >
                                    {_.map(item.list,
                                        (opt, index) => (
                                            <DropdownItem
                                                key={index}
                                                id={opt.key}
                                                onClick={() => opt.onClick(props.index)}
                                            >
                                                {opt.name}
                                            </DropdownItem>
                                        )
                                    )}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        )
                    }
                    // Buttons Cells ( edit And Delete Buttons in one cell)
                    if (item.type === "editAndDeleteButtons") {
                        return (
                            <>
                                <Button
                                    size="sm"
                                    color='success'
                                    className="btn-icon"
                                    onClick={() => item.onEdit(props.index)}>
                                    <i className="fa fa-edit" />
                                </Button>{" "}
                                <Button
                                    size="sm"
                                    color='danger'
                                    className="btn-icon"
                                    onClick={() => item.onDelete(props.index)}>
                                    <i className="fa fa-times" />
                                </Button>
                            </>
                        )
                    }

                    //Checkbox Cells 
                    if (item.type === "checkbox") {
                        return (
                            <div className="mt-n4">
                                <CheckBox
                                    name=""
                                    defaultChecked={props.value ?? props.default ?? false}
                                    disabled={true}
                                    isCenter={true}
                                    onChange={() => { }}
                                />
                            </div>
                        )
                    }
                }
            }

            // to fix drop down items issue
            if (item.type == "dropDownMenu")
                column['getProps'] = () => ({
                    style: { overflow: "unset" }
                })

            return column
        })

        return columns
    }

    const handleChange = event => {
        let searchValue = event.target.value
        globalSearch(searchValue)
    };

    // database search
    const globalSearch = (searchValue) => {

        let filteredData = props.body.filter(value => {

            let keys = _.keys(value)
            _.remove(keys, function (v) { return _.startsWith(v, '_') });

            let isExist = false
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i]
                let colInfo = _.find(props.header, h => _.get(h, 'accessor', '').includes(key))

                if (!colInfo) continue // means this field doesn't display at the table

                let { type = '' } = colInfo

                let fieldData = _.get(value, colInfo.accessor, key)
                if (fieldData && (type === "firestoreTime" || type === "firestoreDateAndTime")) { // convert the date feild
                    fieldData = moment(fieldData.toDate()).format('DD/MM/YYYY HH:mm')
                }
                if (fieldData && (type === 'dateAndTime')) { // convert the date feild
                    fieldData = moment(fieldData).format('DD/MM/YYYY HH:mm:ss')
                }

                let val = typeof (fieldData) === "object" ? JSON.stringify(fieldData) : fieldData
                
                let isSearchValExist = (val && val.toString().toLowerCase().includes(searchValue.toLowerCase()))

                if (isSearchValExist) {
                    isExist = true
                    break
                }

            }      
                  
            return isExist
        })

        setData(filteredData)
        setSearchInput(searchValue)

        try { // avoid error
            props.setFilterResult(filteredData)

        } catch (error) {
            console.log("setFilterResult func not exist", { error })
        }

    }

    return (
        <>
            <div className="content">
                <Row>
                    <Col md="12">
                        <Card>
                            <CardBody>

                                {/* Search */}
                                {props.hasSearchBar && (
                                    <>
                                        <p className="text-muted">{props.searchBarTitle ?? ''}</p>
                                        <Row >
                                            <Col md="12" className="mb-n3 mt-n4">
                                                <FormGroup>
                                                    <InputGroup className="align-items-center">
                                                        <Input
                                                            placeholder={t("search")}
                                                            style={{ height: "50%" }}
                                                            value={searchInput}
                                                            onChange={event => handleChange(event)}
                                                            className='border'
                                                        />
                                                        <InputGroupAddon addonType="append" style={{ zIndex: 0 }}>
                                                            <Button color="info">{t("search")}</Button>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </>
                                )}

                                <ReactTable
                                    data={searchInput.trim() === "" ? props.body : data}
                                    columns={columnsHandler()}
                                    loading={props.loading}
                                    showPagination={true}
                                    showPageSizeOptions={false}
                                    pages={pages}
                                    page={currentPage}
                                    minRows={dataLimits}
                                    className="-striped -highlight primary-pagination"
                                    onPageChange={(pageIndex) => setCurrentPage(pageIndex)}
                                    onSortedChange={() => setCurrentPage(0)}
                                    getTdProps={() => ({
                                        style: {
                                            alignSelf: 'center'
                                        }
                                    })}
                                />

                                {props.loadMoreBtn && (
                                    <Button
                                        color="info"
                                        block={true}
                                        outline={true}
                                        onClick={props.loadMoreBtn.onClick}
                                        disabled={props.loadMoreBtn.isDisabled}
                                    >
                                        {t('loading_more')}
                                    </Button>
                                )}
                                
                                <ExportTo {...props} />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>

        </>
    )

}

export default CustomTable
